module.exports = __webpack_public_path__ + "img/01.1204b7cb.png";